import { Container } from '@mantine/core';

import { ActiveSubscription } from 'Screens/Dashboard/Subscription/ActiveSubscription/ActiveSubscription';
import { InvoiceDetails } from 'Screens/Dashboard/Subscription/InvoiceDetails/InvoiceDetails';
import { PaymentHistory } from 'Screens/Dashboard/Subscription/PaymentHistory/PaymentHistory';
import { PaymentMethods } from 'Screens/Dashboard/Subscription/PaymentMethods/PaymentMethods';
import { SubscriptionPlans } from 'Screens/Dashboard/Subscription/SubscriptionPlans/SubscriptionPlans';
import useGetUser from 'hooks/useGetUser';
import styles from './Subscription.module.scss';
import NotConfiguredEmptyState from 'Components/Common/NotConfiguredEmptyState/NotConfiguredEmptyState';

const Subscription = () => {
    const user = useGetUser();

    if (user && !user.hasInitialSetupCompleted) {
        return (
            <NotConfiguredEmptyState />
        );
    }

    return (
        <Container className={styles.container} fluid py="xl">
            <div className={styles.billingGrid}>
                <div className={styles.billingColumn}>
                    <ActiveSubscription />
                    <InvoiceDetails />
                </div>
                <div className={styles.billingColumn}>
                    <PaymentMethods />
                    <PaymentHistory />
                </div>
            </div>
            <SubscriptionPlans />
        </Container>
    );
};

export default Subscription;
